import { render, staticRenderFns } from "./BgDesign.vue?vue&type=template&id=668ae056&scoped=true"
import script from "./BgDesign.vue?vue&type=script&lang=js"
export * from "./BgDesign.vue?vue&type=script&lang=js"
import style0 from "./BgDesign.vue?vue&type=style&index=0&id=668ae056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ae056",
  null
  
)

export default component.exports